class TemplateArticleJS {
  constructor() {
    window.addEventListener('load', () => this.moveFeaturedProductsSwiper(), { once: true });
  }

  moveFeaturedProductsSwiper() {
    const articleContent = document.querySelector('.template-article .article-content');
    const featuredSection = document.querySelector('.template-article .shopify-section.featured-products');

    if (!articleContent || !featuredSection) return;

    const headings = articleContent.querySelectorAll('h2');
    if (headings.length < 4) return;

    const fourthHeading = headings[3];
    featuredSection.classList.add('article-inline-products');
    fourthHeading.parentNode.insertBefore(featuredSection, fourthHeading);
    this.updateInlineSwiper(featuredSection);
  }

  updateInlineSwiper(section) {
    const swiperEl = section.querySelector('swiper-container');
    if (!swiperEl?.swiper) return;

    const { swiper } = swiperEl;
    if (swiper.params.breakpoints?.[992]) {
      swiper.params.breakpoints[992].slidesPerView = 2;
    }
    swiper.update();
  }
}

typeof TemplateArticleJS !== 'undefined' && new TemplateArticleJS();
